module.exports = __webpack_public_path__ + "assets/img/advantage1.1c63db51.png";